import { Block } from '~/common/components/Block/Block';
import { Form } from '~/common/components/Form/Form';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const TASuccess = ({ application }) => {
  const formatted_pod_realise_date = dayjs.utc(application.pod_realise_date).format('MMMM YYYY')


  return (
    <Block title="TA Confirmation">
    <Form>
        <Form.Row>
          Congrats, you are officially enrolled as a TA in {application.course_name}! Your pod info will be released here in {formatted_pod_realise_date}.
          <br></br>
          <br></br>
          Please be sure to check your email to complete your tax forms and enter your banking information. 
          <br></br>
          <br></br>
          You can see the full process <a href='https://docs.neuromatch.io/p/o-JMxQx6MAY2Bd/Teaching-Assistant-Payment-Instructions' target='_blank' rel='noreferrer'>here</a>. 
          If you have any questions, please email <a href='mailto:support@neuromatch.io' target='_blank' rel='noreferrer'>support@neuromatch.io</a> for all payment questions.
        </Form.Row>
    </Form>
    </Block>
  );
};
